<template>
    <div class="content">

        <toolbar v-bind:selection="toolbar" title="Editar - alimentar colmenar" />

        <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
                    color="orange"
                    label="Nombre colmenar*"
                    v-bind:value="infoFeed.namecolmenar"
                    disabled
            ></v-text-field>


            <v-select
                    v-model="infoform.idcolmena"
                    :items="listhives"
                    item-value="[id]"
                    item-text="[number]"
                    label="Colmenas/núcleos que alimentas*"
                    multiple
                    small-chips

            >
                <template v-slot:prepend-item>
                    <v-list-item
                            ripple
                            @click="toggle"
                    >
                        <v-list-item-action>
                            <v-icon :color="infoform.idcolmena.length > 0 ? 'indigo darken-4' : ''">
                                {{ icon }}
                            </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                Seleccionar todos
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:append-item>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item disabled>
                        <!--v-list-item-avatar color="grey lighten-3">
                            <v-icon>
                                mdi-food-apple
                            </v-icon>
                        </v-list-item-avatar-->

                        <v-list-item-content>
                            <v-list-item-title>
                                {{ infoform.idcolmena.length }} Seleccionados
                            </v-list-item-title>

                        </v-list-item-content>


                    </v-list-item>
                </template>
            </v-select>

            <p class="v-messages__message">{{errors.colmenas}}</p>


            <p for="date" style="font-size:0.69rem;"><b>Fecha de alimentación*</b></p>
            <datepicker
                    style="margin-bottom:20px;"
                    name="date"
                    id="date"
                    v-model="infoform.date"
                    format="dd/MM/yyyy"
                    class="form-datepicker"></datepicker>

            <p class="v-messages__message">{{errors.date}}</p>

            <v-select
                    v-model="infoform.food"
                    class="form-group"
                    color="orange"
                    :items="optionsFood"
                    label="Alimento"
                    data-vv-name="infoform.food"
            ></v-select>


            <div class="row">
                <div class="col-d-5">
                    <v-select
                            v-model="infoform.amount"
                            class="form-group"
                            color="orange"
                            :items="optionsAmount"
                            label="Cantidad por colmena"
                            data-vv-name="infoform.amount"
                    ></v-select>
                </div>
                <div class="col-d-3">
                    <v-select
                            v-model="infoform.amount_decimal"
                            class="form-group"
                            color="orange"
                            :items="optionsAmountDecimal"
                            data-vv-name="infoform.amount_decimal"
                    ></v-select>
                </div>

                <div class="col-d-4">
                    <v-select
                            v-model="infoform.measure"
                            class="form-group"
                            color="orange"
                            :items="optionsMeasure"
                            data-vv-name="infoform.measure"
                    ></v-select>


                </div>

            </div>


            <p><b>Descripción</b></p>
            <v-col class="col" cols="12" md="6">
                <v-textarea
                        solo
                        name="description"
                        label="Notas, comentarios..."
                        v-model="infoform.note"
                ></v-textarea>
            </v-col>



            <loading v-bind:isloading="isloading" ></loading>

            <v-alert
                    dense
                    v-bind:type="alertForm"
                    text
                    :value="alert"
                    transition="scale-transition"
            >
                {{responseform}}
            </v-alert>


            <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
                EDITAR
            </v-btn>

        </v-form>

    </div>


</template>

<script>
import auth from "@/libs/auth"


import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"
import Datepicker from 'vuejs-datepicker';
import {es} from 'vuejs-datepicker/dist/locale'
import axios from "axios";

export default {

    name: 'alimentar-nueva',

    components: {
        toolbar,loading,Datepicker,
    },
    data() {
        return {

        toolbar: {
                return: '0'
            },

            valid: true,


            es: es,

            errors: {
                date:'',
                colmenas:'',
            },


            isloading:'',

            alertForm:'success',
            responseform:'',
            alert: false,

            optionsAmount: [
              { text: '0', value: '0' },
              { text: '1', value: '1' },
              { text: '2', value: '2' },
              { text: '3', value: '3' },
              { text: '4', value: '4' },
              { text: '5', value: '5' },
              { text: '6', value: '6' },
              { text: '7', value: '7' },
              { text: '8', value: '8' },
              { text: '9', value: '9' },
              { text: '10', value: '10' },
              { text: '11', value: '11' },
              { text: '12', value: '12' },
              { text: '13', value: '13' },
              { text: '14', value: '14' },
              { text: '15', value: '15' }
            ],

            optionsFood: [
              { text: 'Tarta proteina', value: 'tarta' },
              { text: 'Sirope', value: 'sirope' },
              { text: 'Sólido', value: 'solido' }
            ],


            optionsAmountDecimal: [
              { text: ',0', value: ',0' },
              { text: ',25', value: ',25' },
              { text: ',50', value: ',50' },
              { text: ',75', value: ',75' }
            ],


            optionsMeasure: [
              { text: 'Kg', value: 'kg' },
              { text: 'Litro', value: 'l' }
            ],

            infoColmenar:null,

            infoform: {
                idcolmena: [],
                date: '',
                food: '',
                amount: '',
                amount_decimal: '',
                measure: '',
                note: ''
            },
            response: null,
            colmenar:null,
            listhives:[],
            hives:[],
            hives_id:'',
            hives_feed:[],
            infoFeed: null,

            select: ['Vuetify', 'Programming'],
        items: [
          'Programming',
          'Design',
          'Vue',
          'Vuetify',
        ],


  }},
  computed: {
      likesAllHives () {
        return this.infoform.idcolmena.length === this.listhives.length
      },
      likesSomeHives () {
        return this.infoform.idcolmena.length > 0 && !this.likesAllHives
      },
      icon () {
        if (this.likesAllHives) return 'mdi-close-box'
        if (this.likesSomeHives) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },

    },

  created() {
  auth.getUserLogged()
    this.getTodos();
  },
  methods:{

  toggle () {
        this.$nextTick(() => {
          if (this.likesAllHives) {
            this.infoform.idcolmena = []
          } else {

            for (var j = 0; j < this.listhives.length; j++){

                this.hives[j] = this.listhives[j]['id']

               // alert(this.listhives[j]['idcolmena'])

            }
            this.infoform.idcolmena = this.hives
          }
        })
      },

        async getTodos(){

            var that = this

         /*   that.infoform.idcolmenar = that.idcolmenar */


         await axios.get('https://appws.panimiel.com/new/index.php/api/hive_feed/detail/'+this.$route.params.id)
            .then(function (infoFeed) {
              that.infoFeed = infoFeed.data;
              that.infoform.date = that.infoFeed.date
              that.infoform.food = that.infoFeed.food
              that.infoform.amount = that.infoFeed.amount
              that.infoform.amount_decimal = that.infoFeed.amount_decimal
              that.infoform.measure = that.infoFeed.measure
              that.infoform.note = that.infoFeed.note

            })

            axios.get('https://appws.panimiel.com/new/index.php/api/colmena/'+this.infoFeed.idcolmenar+'/2/0')
            .then(function (response) {
              that.listhives = response.data;
            })

            axios.get('https://appws.panimiel.com/new/index.php/api/hive_feed/detail_hives/'+this.$route.params.id)
            .then(function (hives_feed) {
           //   that.hives_feed = hives_feed.data

              that.infoform.idcolmena = hives_feed.data
            })


        },
        validate () {

            this.$refs.form.validate()

            if(this.infoform.idcolmena==""){

                this.errors.colmenas = "Debes seleccionar al menos una colmena."
            }
            if(this.infoform.date===''){
                this.errors.date = "Debes insertar la fecha de la alimentación."
            }else if(this.$refs.form.validate() && this.infoform.idcolmena!=""  && this.infoform.date!=""){

                this.alert = false
                this.isloading = true

                this.errors.date = ''
                this.errors.colmenas = ''


                axios.put('https://appws.panimiel.com/new/index.php/api/hive_feed/'+this.$route.params.id, this.infoform).then((response) => {
                    this.responseform = response.data


                     this.alertForm = 'success'
                     this.isloading=''
                     this.alert = true

                })
                .catch((error) => {
                    this.alertForm = 'error',
                    this.isloading=''

                    if (error.response.status != 500){
                        this.responseform = error.response.data
                    }else{
                        this.responseform = 'Error, no ha sido posible crear la alimentación.'
                    }
                     this.alert = true

                 })

            }

        }

    }


};


</script>

<style scoped lang="scss">
</style>